//#region src/modules/menubar/utils/url.ts
function isValidFullUrl(string) {
	try {
		new URL(string);
		return true;
	} catch (error) {
		return false;
	}
}
//#endregion
export { isValidFullUrl };
